import { CurrentUser } from '@app/@types/users'
import { GoogleAuth, Market, MicrosoftAuth, Root } from '@app/lib/graphql'

export const currentUserStickyStateKey = 'currentUserSettings'

export type CurrentUserStickyState = {
	defaultRoot?: Root | null
	filters?: any
	microsoftAuth?: MicrosoftAuth | null
	googleAuth?: GoogleAuth | null
	defaultMarket?: Market | null
}

export type CurrentUserContextState = {
	currentUser?: CurrentUser
	permissions: string[]

	setDefaultUserSettings: (
		newDefaultRoot?: Root | null,
		filters?: any,
		tableName?: string,
		newDefaultMarket?: Market | null
	) => void
	updateUserSettings: (userSettings: CurrentUserStickyState) => void
	deleteDefaultUserSettings: () => void
}

export type useCurrentUserType = {
	(): {
		currentUser?: CurrentUser
		setDefaultUserSettings: (
			newDefaultRoot?: Root | null,
			filters?: any,
			tableName?: string,
			newDefaultMarket?: Market | null
		) => void
		updateUserSettings: (userSettings: CurrentUserStickyState) => void
		deleteDefaultUserSettings: () => void
	}
}
